/**
 * Implementation of Transporter Factory Interface for calling submit directly to petrol
 */
import { Transporter } from "./../Transport/Transport";
import * as Configuration from "./../Configuration/Configuration";
export default class TransporterFactory {
  makeTransporter(surveyType) {
    return new Transporter(Configuration.get().getCommonInitOptions().environment, surveyType, Configuration.get().getCommonInitOptions().appId, "Survey", Configuration.get().getCommonInitOptions().applicationGroup, Configuration.get().getCommonInitOptions().telemetryGroup, Configuration.get().getCommonInitOptions().webGroup);
  }
}